import type { CategoriesApi } from "@/v2/api/metadata/categories";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { TranslationsTab } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { formatTranslationsForUpdate } from "@/services/helpers";
import { buildCategoryTranslationFields } from "../../translation-fields";

export function createTranslationsTab(options: {
  ctx: BackofficeContext;
  categoriesApi: CategoriesApi;
}): TranslationsTab {
  const { ctx, categoriesApi } = options;

  return {
    kind: "translations",
    id: "translations",
    label: "Translations",
    persistence: "isolated",
    parentSubmitWithUnsavedTranslations: "block",
    fields: buildCategoryTranslationFields,
    api: {
      get: async ({ values }) => {
        const category = values as { id: string | number };
        const translations = readApiData(await categoriesApi.getTranslations(category.id));
        const list = Array.isArray(translations) ? translations : [];

        const languages = ctx.read.languages();
        const translationsPerLanguage = (list as Array<{ languageId: string | number }>).reduce(
          (acc, translation) => {
            acc.set(String(translation.languageId), translation);
            return acc;
          },
          new Map(),
        );

        return {
          languages,
          translationsPerLanguage,
        };
      },
      save: async (model, saveCtx) => {
        const categoryId = (saveCtx.values as { id: string | number }).id;
        await categoriesApi.update(categoryId, {
          translations: formatTranslationsForUpdate(
            model as Parameters<typeof formatTranslationsForUpdate>[0],
          ),
        });
      },
    },
  };
}
